var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('p',[_vm._v("Copyright © 2022 琼ICP备2022015118号 荣鼎盛和（海南）实业有限公司")])])}]

export { render, staticRenderFns }